<template>
    <div>
        <div class="page-wrapper">
            <div class="page-header d-print-none">
                <div class="container-xl">
                    <div class="row g-2 align-items-center">
                        <div class="col">
                            <div class="page-pretitle">
                                Usted se encuentra aquí:
                            </div>
                            <h2 class="page-title">
                                Acerca de
                            </h2>
                        </div>
                    </div>
                </div>
            </div>
            <div class="page-body">
                <div class="container-xl">
                    <div class="row row-cards">
                        <div class="col-lg-12">
                            <div class="card card-lg">
                                <div class="card-body">
                                    <div class="markdown">
                                        <h2>¿De qué se trata datos abiertos?</h2>
                                        <p :align="'justify'">Los datos abiertos pueden ser libremente usados, re-utilizados y redistribuidos, sujeto en algunos casos, a requisitos de atribución y redistribución con la misma licencia. Los Datos Abiertos Gubernamentales son un medio fundamental para fomentar la transparencia, facilitando a los ciudadanos el acceso a la información de la gestión del Gobierno. Los ciudadanos pueden así empoderarse de los procesos de decisión, ayudando al gobierno en la toma de mejores decisiones y colaborando en la propuesta de soluciones. La Contraloría General de la República impulsa esta iniciativa en el marco de las políticas de transparencia y lucha contra la corrupción.</p>
                                        <h2>¿Cómo puedo usar los datos?</h2>
                                            <p :align="'justify'">Con los Datos Abiertos se pueden crear visualizaciones innovadoras para comprender mejor los datos complejos, fomentando la creación de nuevos conocimientos. Se pueden procesar los datos para obtener diferentes tipos de análisis, aplicaciones, u otra información que derive de los mismos y que sirva para aportar algo nuevo sobre el sector que se trate, en este caso el de las denuncias por hechos de corrupción y los procesos iniciados sobre las mismas.
                                            </p>
                                        <h2>¿Quiénes están involucrados en el proyecto?</h2>
                                            <p :align="'justify'">El portal a datos abiertos está desarrollado por la Contraloría General de la República (CGR).
                                            </p>
                                        <h2>Aclaración sobre los Registros con Opción de Sistema y Escaneado</h2>
                                        <h3>Registros con Opción de Sistema.</h3>                                    
                                        <p :align="'justify'">
                                                Los registros que cuentan con la opción <strong>SISTEMA</strong> provienen de nuestra base de datos digital, donde la información ha sido ingresada directamente en formato electrónico. Estos registros son susceptibles de presentar variaciones en su formato, ya sea debido a actualizaciones en la estructura de la base de datos o a modificaciones en la presentación de los datos. A pesar de estas posibles variaciones, la integridad y la calidad de la información proporcionada no se encuentra comprometida.                                               
                                        </p>
                                        <h3>Registros con Opción Escaneado.</h3>                                    
                                        <p :align="'justify'">
                                            Los registros marcados como <strong>ESCANEADOS</strong> corresponden a documentos físicos que han sido digitalizados para su inclusión en nuestra base de datos abiertos. Estos archivos pueden presentar limitaciones en cuanto a la búsqueda y manipulación de texto, ya que están en formato de imagen o PDF. Sin embargo, hemos implementado medidas para garantizar la legibilidad y accesibilidad de estos documentos tanto como sea posible.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    // eslint-disable-next-line vue/multi-word-component-names
    name: 'AcercaDe',
    data() {
        return {
            content: '',
        };
    }
};


</script>